import { Model, UIField, UIIconButton, useEffectAsync } from "@alphascriptsolutions/client-core";
import { message } from "antd";
import useState from "react-usestateref";
import Renderer from "../components/Renderer";
import { Placeholder } from "../utils/entities";
import { useEffect } from "react";
import { STORAGE_KEY_SelectedShapes } from "../utils/sharePricePerformance/selectedPlaceHolderLocalStorage";

export default function Placeholder() {
  const [model, setModel, modelRef] = useState<Model | null>(null);
  const [placeholder, setplaceholder, plceholderRef] = useState<Placeholder | null>(null);
  const [changed, setChanged] = useState<boolean>(false);

  const setAllModelNavigationBtns = (model: Model) => {
    const placeholderSelectionBtn = model.getByName<UIIconButton>("placeholderSelectionBtn");
    if (placeholderSelectionBtn) {
      placeholderSelectionBtn.onClick = () => {
        const isAlphaAgentPlaceholder = localStorage.getItem("AlphaAgentPlaceholder");
        const isAlphaAgentEditPlaceholder = localStorage.getItem("AlphaAgentEditPlaceholder");
        const placeholderPopupFlag = localStorage.getItem("PlaceholderPopupFlag");
        if (placeholderPopupFlag === "true") {
          Office.context.ui.messageParent("CLOSE_PLACEHOLDER_PLACEHOLDER_POPUP");
        } else if (isAlphaAgentPlaceholder === "true") {
          Office.context.ui.messageParent("CLOSE_PLACEHOLDER_ALPHA_AGENT");
        } else if (isAlphaAgentEditPlaceholder === "true") {
          Office.context.ui.messageParent("CLOSE_PLACEHOLDER_ALPHA_AGENT_EDIT");
        } else {
          Office.context.ui.messageParent("CLOSE_PLACEHOLDER");
        }
      };
    }
  };

  useEffectAsync(async () => {
    const path = "/assets/placeholder/PlaceholderSelection.yml";

    try {
      let loadedModel = await Model.fromFile(path);
      if (!loadedModel.isValid()) {
        throw new Error(`Problem loading model from ${path}: ${loadedModel.getError()}`);
      }

      setAllModelNavigationBtns(loadedModel);

      setModel(loadedModel);
    } catch (err) {
      message.error(err.message);
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY_SelectedShapes && event.newValue) {
        const newValue = JSON.parse(event.newValue);
        setplaceholder(newValue);
        setChanged(false);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (!model) return;
    const modelToUpdate = modelRef.current;
    const textFieldForPlaceholder = modelToUpdate.getByName<UIField>("placeholderSelectionName");

    const { name } = plceholderRef.current;
    if (textFieldForPlaceholder) {
      textFieldForPlaceholder.value = name;
      setChanged(true);
    }

    setModel(() => modelToUpdate);
  }, [placeholder, changed]);

  return (
    <div>
      <Renderer model={model} />
    </div>
  );
}
